import { configureStore } from "@reduxjs/toolkit";

import axiosMiddleware from "./middlewares/axiosMiddleware";
import authReducer from "./redux/authSlice";
import userReducer from "./redux/userSlice";
import tableReducer from "./redux/tableSlice";
import analysisReducer from "./redux/analysisSlice";
import promptReducer from "./redux/promptSlice";
import toastReducer from "./redux/toastSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        table: tableReducer,
        analysis: analysisReducer,
        prompt: promptReducer,
        toast: toastReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}).concat(axiosMiddleware)
})

export default store;